export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const DELETE_USER = 'DELETE_USER';
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const REGISTER = 'REGISTER';
export const VALIDATE_TOKEN = 'VALIDATE_TOKEN';


export function loginAction({ username, password, facebook=true, accessToken=null }) {
  return {
    type: LOGIN,
    payload: { username, password, facebook, accessToken }
  };
}

export function changePasswordAction({ oldPassword, newPassword }) {
  return {
    type: CHANGE_PASSWORD,
    payload: { old_password: oldPassword, new_password: newPassword }
  };
}

export function logoutAction() {
  return {
    type: LOGOUT
  };
}

export function deleteUserAction() {
  return {
    type: DELETE_USER
  };
}

export function registerAction(username, password) {
  return {
    type: REGISTER,
    payload: { username, password }
  };
}

export function validateTokenAction() {
  return {
    type: VALIDATE_TOKEN
  };
}


// WEBPACK FOOTER //
// ./src/redux/actions/auth.actions.js